/**
 * Maps all inputs to their according fieldSets and exposes the method on model.
 */
const mapFieldsetsWithParams = (parameter) => {
  const FSPMap = new Map();

  Object.keys(parameter).forEach((key) => {
    const param = parameter[key];
    const { fieldSet } = parameter[key];
    if (fieldSet !== undefined && fieldSet !== null) {
      if (FSPMap.has(fieldSet)) {
        // update fieldSet value if we already have one
        const fieldsetArray = FSPMap.get(fieldSet);
        fieldsetArray.push(param);
        FSPMap.set(fieldSet, fieldsetArray);
      } else {
        // set fieldSet as key with an array of the corresponding param
        FSPMap.set(fieldSet, [param]);
      }
    }
  });

  // Map to Array of Objects for easier use ins jsx.
  return Array.from(FSPMap, el => ({ fieldSet: el[0], inputs: el[1] }));
};

export default mapFieldsetsWithParams;
